import { render, staticRenderFns } from "./RelatedService.vue?vue&type=template&id=bbd612d6&"
import script from "./RelatedService.vue?vue&type=script&lang=js&"
export * from "./RelatedService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports